import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { StarMark, Wordmark } from "./StarMark";
import { SERVICES, TAGLINE, waLink, DEFAULT_WA_TEXT } from "../lib/data";

export const Footer = () => (
  <footer className="relative border-t-4 border-gold bg-brand-dark" data-testid="footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <StarMark size={40} />
          <Wordmark className="text-xl" />
        </div>
        <p className="mt-4 font-script text-2xl text-gold-light">{TAGLINE}</p>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-blush">
          Magie, circus & unieke shows voor elk feest. Voor bedrijven en particulieren, heel België!
        </p>
      </div>

      <div>
        <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-gold">Diensten</p>
        <ul className="mt-5 space-y-3">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link
                to={`/diensten/${s.slug}`}
                data-testid={`footer-link-${s.slug}`}
                className="group flex items-center gap-2 text-sm font-semibold text-snow transition-colors hover:text-gold-light"
              >
                <Star size={9} className="fill-gold text-gold transition-transform duration-300 group-hover:rotate-180" />
                {s.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-gold">Contact</p>
        <ul className="mt-5 space-y-3 text-sm font-semibold text-snow">
          <li>
            <a
              href={waLink(DEFAULT_WA_TEXT)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="transition-colors hover:text-whatsapp"
            >
              WhatsApp — snelste antwoord!
            </a>
          </li>
          <li>
            <Link to="/contact" data-testid="footer-link-contact" className="transition-colors hover:text-gold-light">
              Boekingsformulier
            </Link>
          </li>
          <li className="text-blush">Heel België & Nederland</li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/15 py-6 text-center text-xs font-semibold text-blush">
      © {new Date().getFullYear()} entertainmentshows.be — Alle rechten voorbehouden
    </div>
  </footer>
);
